import { createSignal } from 'simple-react-signal';
import type { ApolloClient } from '@apollo/client';

export const apolloClientSignal = createSignal<ApolloClient<object> | null>(null);
export const apolloAdminClientSignal = createSignal<ApolloClient<object> | null>(null);
export const apolloUserClientSignal = createSignal<ApolloClient<object> | null>(null);
